import React, { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { JobHttpService } from 'cms/features/feature_job/service';
import JobForm from '../components/JobForm';
import {
    Box,
    Container,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Alert,
    Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function NewJobPage() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const [formOpen, setFormOpen] = useState(true);

    // Load user's company
    const { data: company, isLoading: companyLoading } = useQuery(
        'myCompany',
        () => JobHttpService.loadMyCompany()
    );

    const handleFormClose = () => {
        setFormOpen(false);
        navigate('/employer/jobs');
    };

    const handleJobSaved = () => {
        queryClient.invalidateQueries(['employerJobs', company?.id]);
        queryClient.invalidateQueries('myCompany');
    };

    if (companyLoading) {
        return (
            <section className="section-box mt-50">
                <Container maxWidth="lg">
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                </Container>
            </section>
        );
    }

    if (!company) {
        return (
            <section className="section-box mt-50">
                <Container maxWidth="lg">
                    <Alert severity="warning" sx={{ mb: 3 }}>
                        You need to create a company first. <Button href="/employer/my-company">Go to My Company</Button>
                    </Alert>
                </Container>
            </section>
        );
    }

    return (
        <section className="section-box mt-50">
            <Container maxWidth="lg">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('/employer/jobs')}
                    sx={{ mb: 3 }}
                >
                    Back to Jobs
                </Button>

                <Card>
                    <CardContent sx={{ p: 3 }}>
                        <Typography variant="h4" fontWeight={600} gutterBottom>
                            Create New Job
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Fill in the details below to post a new job opening.
                        </Typography>
                    </CardContent>
                </Card>

                <JobForm
                    open={formOpen}
                    onClose={handleFormClose}
                    jobId={null}
                    companyId={company.id}
                    onSaved={handleJobSaved}
                />
            </Container>
        </section>
    );
}

export default NewJobPage;
